import type { AlertSeverity } from '../api/types';

const STYLE: Record<AlertSeverity, string> = {
  info: 'bg-mist text-muted-2',
  warning: 'bg-warning-bg text-warning-ink',
  critical: 'bg-danger-bg text-danger-ink',
};

/** `casing="title"` is the Alerts detail pill ("Critical"); the default stays upper case. */
export default function AlertSeverityBadge({ severity, casing = 'upper' }: { severity: AlertSeverity; casing?: 'upper' | 'title' }) {
  return (
    <span className={`inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-semibold ${STYLE[severity]}`}>
      {casing === 'title' ? severity.charAt(0).toUpperCase() + severity.slice(1) : severity.toUpperCase()}
    </span>
  );
}
